"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ButtonIcon = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("what-input");

require("@paprika/helpers/lib/polyfills/elementClosest");

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _Refresh = _interopRequireDefault(require("@paprika/icon/lib/Refresh"));

var _CaretDown = _interopRequireDefault(require("@paprika/icon/lib/CaretDown"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var sc = _interopRequireWildcard(require("./Button.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var ButtonIcon = function ButtonIcon(props) {
  return props.children ? /*#__PURE__*/_react["default"].createElement(sc.ButtonIcon, (0, _extends2["default"])({
    "data-pka-anchor": "button.icon"
  }, props)) : null;
};

exports.ButtonIcon = ButtonIcon;

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      icon = props.icon,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isDropdown = props.isDropdown,
      isPending = props.isPending,
      isSemantic = props.isSemantic,
      isSubmit = props.isSubmit,
      kind = props.kind,
      onClick = props.onClick,
      role = props.role,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "icon", "isActive", "isDisabled", "isDropdown", "isPending", "isSemantic", "isSubmit", "kind", "onClick", "role", "tabIndex"]);
  if (a11yText) moreProps["aria-label"] = a11yText;

  var buttonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        buttonRef.current.focus();
      }
    };
  });

  var isButtonDisabled = isDisabled || isPending;

  function handleSubmit(event) {
    var $form = event.target.closest("form");
    var button = $form.ownerDocument.createElement("input");
    button.style.display = "none";
    button.type = "submit";
    $form.appendChild(button).click();
    $form.removeChild(button);
  }

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);

    if (isSubmit && !isSemantic) {
      handleSubmit(event);
    }

    if (!canPropagate) event.stopPropagation();
    if (!isButtonDisabled) onClick(event);
  };

  var bestTabIndex = isButtonDisabled && tabIndex === null ? -1 : tabIndex || 0;

  function handleBlur(event) {
    if ("onBlur" in moreProps) {
      moreProps.onBlur(event);
    }

    setHasForcedFocus(false);
  }

  var buttonProps = _objectSpread(_objectSpread({
    "aria-pressed": isActive,
    "data-pka-anchor": "button",
    tabIndex: tabIndex
  }, moreProps), {}, {
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isButtonDisabled,
    kind: kind,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: buttonRef
  });

  if (isSemantic) {
    buttonProps.disabled = isButtonDisabled;
    buttonProps.type = isSubmit ? "submit" : "button";
    if (role !== "button") buttonProps.role = role;
  } else {
    buttonProps.tabIndex = bestTabIndex;
    buttonProps.role = role;
  }

  var iconProps = {
    isDisabled: isButtonDisabled,
    kind: kind
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Button, (0, _extends2["default"])({
    as: isSemantic ? "button" : _rawButton["default"]
  }, buttonProps), /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isPending: isPending
  }), isPending ? /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null) : icon), children, /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({}, iconProps, {
    isSuffixIcon: true
  }), isDropdown && /*#__PURE__*/_react["default"].createElement(_CaretDown["default"], null)));
});

Button.types = {
  size: constants.defaultSize,
  kind: constants.kind
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node,

  /** An icon to be included to the left of children content. */
  icon: _propTypes["default"].node,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If the button includes a down arrow to the right of children content. */
  isDropdown: _propTypes["default"].bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes["default"].bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes["default"].bool,

  /** If it will be rendered as a <button> element. If false, a <span> will be rendered via an accessible <RawButton>. */
  isSemantic: _propTypes["default"].bool,

  /** If the type attribute should "submit", instead of the default "button". */
  isSubmit: _propTypes["default"].bool,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Button.types.kind.DEFAULT, Button.types.kind.PRIMARY, Button.types.kind.SECONDARY, Button.types.kind.DESTRUCTIVE, Button.types.kind.FLAT, Button.types.kind.MINOR, Button.types.kind.LINK]),

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Button.types.size.SMALL, Button.types.size.MEDIUM, Button.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  children: null,
  icon: null,
  isActive: null,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSemantic: true,
  isSubmit: false,
  kind: Button.types.kind.DEFAULT,
  onClick: function onClick() {},
  role: "button",
  size: Button.types.size.MEDIUM,
  tabIndex: null
};
var buttonPropTypes = {
  children: _propTypes["default"].node
};
var buttonDefaultProps = {
  children: null
};
Button.displayName = "Button";
ButtonIcon.propTypes = buttonPropTypes;
ButtonIcon.defaultProps = buttonDefaultProps;
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map